import {HttpErrorResponse,HttpEvent,HttpHandler,HttpInterceptor,HttpRequest} from '@angular/common/http';
import {Injector} from '@angular/core';
import {Router} from '@angular/router';
import {JhiAlertService,JhiEventManager} from 'ng-jhipster';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {LoginService} from 'src/app/core';
import {Principal} from '../../core/auth/principal.service';
import {CommonUtils} from './../../shared/util/common-utils';



export class ErrorHandlerInterceptor implements HttpInterceptor {
    private principal: Principal;
    private alertService: JhiAlertService;
    constructor(
        private eventManager: JhiEventManager,
        private injector: Injector,
        private loginService: LoginService,
        private router: Router,
        private jhiAlertService: JhiAlertService
    ) {
        setTimeout(() => (this.alertService = injector.get(JhiAlertService)));
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(
                (event: HttpEvent<any>) => {},
                (err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        let currentUrl=window.location.href;
                        let checkPasswordResetUrl=currentUrl.includes("/reset/finish")
                        if (!(err.status === 401 && (err.message === '' || (err.url && err.url.indexOf('/api/account') === 0))) && !checkPasswordResetUrl) {
                            if (this.eventManager !== undefined && !err.url.includes('/api/authentication' ) && (CommonUtils.isNotNil(err.error!.message) && err.error.message!='Please provide valid IMO number')) {
                                this.eventManager.broadcast({ name: 'tdisstudioApp.httpError', content: err });
                            }
                            if (
                              err.error.error === "Forbidden"
                            ) {
                                // this.alertService.error(err.error.message, null, null);
                                this.loginService.logout();
                            }
                        }

                        // if(err.status===400) {
                        //     this.jhiAlertService.error(err.error.message)
                        // }

                        if (err.status === 401 && err.url && !err.url.includes('/api/account') && !err.url.includes('/api/logout')&& !err.url.includes('/api/authentication')) {
                            this.alertService.error(err.error.message, null, null);
                            this.loginService.logout();
                            // const authServer: AuthServerProvider = this.injector.get(AuthServerProvider);
                            // authServer.logout();
                        }
                        if (
                            err.status === 500 &&
                            (err.error.payload === 'Full authentication is required to access this resource' &&
                                !err.url.includes('/api/account') && !err.url.includes('/api/logout')  )
                        ) {
                            // const destination = this.stateStorageService.getDestinationState();

                            // const authServer: AuthServerProvider = this.injector.get(AuthServerProvider);
                            // authServer.logout();
                            this.loginService.logout();
                        }
                        if (err.error!=undefined && (err.error.status && err.error.status == 'BAD_REQUEST' && err.error.message === '401 Unauthorized') && !err.url.includes('/api/logout')) {
                            this.alertService.error(err.error.message, null, null);
                            this.loginService.logout();
                        }
                    }
                }
            )
        );
    }
}
